module.exports = __webpack_public_path__ + "img/about_1.5cda4c27.png";